export interface RegisterLead {
    name: string;
    phone: string;
    origin: string;
    stage: LeadStageEnum;
    attendantId: string;
}

export enum LeadStageEnum {
  NAO_CLASSIFICADO = "NAO_CLASSIFICADO",
  PERDIDO = "PERDIDO",
  EM_CONTATO = "EM_CONTATO"
}
